const CONSTS = {
    //BASE_API_URL: "https://enolawebapi.josal28104.workers.dev/" // old api verson with reverse proxy
    //BASE_API_URL: "https://qa.enolahelp.com/api/v2"
    BASE_API_URL: "https://enolahelp.com/api/v2/"
    //
};
export default CONSTS;
